// Зөвлөгөө (сурагч): нэг уулзалт — товч мэдээлэл, нэгдэх (онлайн) / өрөө (биечлэн), зөвлөхийн тэмдэглэл + зөвлөмж,
// өгсөн ажил, миний хувийн тэмдэглэл (автоматаар хадгална), сэдэв ба хүсэлт, үнэлгээ (дууссаны дараа).
// Дууссан уулзалтын мэдэгдэл энэ хуудас руу (/counseling/:id) холбогдоно.
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Input, Modal, Popconfirm, Spin, message } from "antd";
import { FiArrowLeft, FiClock, FiExternalLink, FiInbox, FiMapPin, FiVideo, FiXCircle } from "react-icons/fi";
import ActionItem from "./ActionItem";
import {
  api, Avatar, Badge, Empty, Star, Stars, STAR_WORDS, fullName, goldBtn, hm, longDate, purpleBtn, timeRange, typeText,
} from "./common";

const Card = ({ children, className = "", ...rest }) => (
  <section className={`tds-card px-4 py-4 md:px-6 md:py-5 flex flex-col gap-3 min-w-0 ${className}`} {...rest}>{children}</section>
);
const Info = ({ label, value }) => (
  <div className="border border-[#E5D8F5] rounded-xl px-3.5 py-3 bg-[#FAF7FF] min-w-0">
    <dt className="text-xs font-semibold text-[#6E5E8A]">{label}</dt>
    <dd className="mt-1 mb-0 text-[15px] font-bold text-gray-900 break-words">{value}</dd>
  </div>
);
const canCancel = (m) => ["requested", "confirmed"].includes(m.status) && Date.parse(m.startTime) > Date.now();
const durationText = (m) => {
  if (m.stage === "done" && m.startedAt && m.endedAt) {
    const min = Math.round((Date.parse(m.endedAt) - Date.parse(m.startedAt)) / 60000);
    if (min > 0) return `${min} минут`;
  }
  return `${m.durationMin || 60} минут`;
};

// Уулзалтын гол хэсэг (бараан) — үе шатаар
function Hero({ m, onCancel, cancelling }) {
  const online = m.type === "online";
  const cancelBtn = canCancel(m) && (
    <Popconfirm title="Уулзалтыг цуцлах уу?" description="Цаг дахин бусдад нээлттэй болно." okText="Цуцлах" cancelText="Үгүй" okButtonProps={{ danger: true }} onConfirm={onCancel}>
      <button type="button" disabled={cancelling} className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#E5D8F5] hover:text-white underline underline-offset-4">
        <FiXCircle size={15} /> {m.stage === "requested" ? "Хүсэлтээ цуцлах" : "Уулзалтыг цуцлах"}
      </button>
    </Popconfirm>
  );
  const join = online && m.meetingLink && (
    <a href={m.meetingLink} target="_blank" rel="noopener noreferrer" className={`${goldBtn} !h-12 !px-6 !text-base`}>
      <FiVideo size={19} /> Уулзалтад нэгдэх <FiExternalLink size={15} className="opacity-70" />
    </a>
  );
  const Circle = ({ children, bg = "#0E7490", size = 80 }) => (
    <span className="rounded-full inline-flex items-center justify-center font-extrabold text-white" style={{ width: size, height: size, background: bg, fontSize: size * 0.34 }}>{children}</span>
  );
  const ini = `${(m.counselor?.firstName || "?").charAt(0)}${(m.counselor?.lastName || "").charAt(0)}`.toUpperCase();

  let body;
  if (m.stage === "requested") {
    body = (
      <>
        <Circle bg="#3d1b6e"><FiClock size={30} /></Circle>
        <span className="text-lg font-bold">Зөвлөхийн баталгаажуулалт хүлээж байна</span>
        <span className="text-sm text-[#E5D8F5] max-w-md leading-relaxed">
          {fullName(m.counselor)} таны хүсэлтийг баталгаажуулмагц мэдэгдэл ирнэ.{online ? " Google Meet холбоос энд гарна." : ""}
        </span>
        {cancelBtn}
      </>
    );
  } else if (m.stage === "upcoming") {
    body = online ? (
      <>
        <Circle>{ini}</Circle>
        <span className="text-base md:text-lg font-semibold">Уулзалт {longDate(m.startTime)}, {hm(m.startTime)}-д эхэлнэ · Google Meet</span>
        {join || <span className="text-sm text-[#E5D8F5]">Google Meet холбоосыг зөвлөх удахгүй оруулна.</span>}
        {cancelBtn}
      </>
    ) : (
      <>
        <Circle bg="#3d1b6e" size={72}><FiMapPin size={30} /></Circle>
        <span className="text-lg font-bold">{m.room || "Зөвлөхийн өрөө"}</span>
        <span className="text-sm text-[#E5D8F5]">{longDate(m.startTime)}, {hm(m.startTime)}-д биечлэн уулзана.</span>
        {cancelBtn}
      </>
    );
  } else if (m.stage === "live") {
    body = (
      <>
        <span role="status" className="inline-flex items-center gap-2 text-sm font-bold bg-[#2a1245] px-3 py-1.5 rounded-full">
          <span className="h-2.5 w-2.5 rounded-full bg-[#00BCD4] animate-pulse" /> Явагдаж байна{m.startedAt ? ` · ${hm(m.startedAt)}-с` : ""}
        </span>
        {online ? (
          <>
            <Circle>{ini}</Circle>
            <span className="text-lg font-bold">{fullName(m.counselor)} таныг хүлээж байна</span>
            {join || <span className="text-sm text-[#E5D8F5]">Google Meet холбоос оруулаагүй байна — зөвлөхтэйгөө холбогдоно уу.</span>}
          </>
        ) : (
          <>
            <Circle bg="#3d1b6e" size={72}><FiMapPin size={30} /></Circle>
            <span className="text-lg font-bold">Биечлэн уулзалт явагдаж байна</span>
            <span className="text-sm text-[#E5D8F5]">{m.room || "Зөвлөхийн өрөө"} · {fullName(m.counselor)}</span>
          </>
        )}
      </>
    );
  } else if (m.stage === "cancelled") {
    body = (
      <>
        <Circle bg="#3d1b6e" size={64}><FiXCircle size={28} /></Circle>
        <span className="text-lg font-bold">Уулзалт цуцлагдсан</span>
        <Link to="/counseling/book" className={`${goldBtn}`}>Шинэ цаг захиалах</Link>
      </>
    );
  } else {
    return null;
  }
  return (
    <section aria-label="Уулзалт" className="bg-[#1a0b2e] text-white rounded-2xl overflow-hidden">
      <div className="min-h-[260px] md:aspect-[16/8] flex flex-col items-center justify-center gap-4 px-5 py-8 text-center">{body}</div>
    </section>
  );
}

function CounselorNotes({ m }) {
  const summary = m.notes.filter((n) => n.kind === "summary");
  const tips = m.notes.filter((n) => n.kind === "tip");
  return (
    <Card aria-labelledby="cn-h">
      <div className="flex items-center gap-2.5">
        <Avatar person={m.counselor} size={30} dark />
        <h2 id="cn-h" className="tds-h2">Зөвлөхийн тэмдэглэл</h2>
      </div>
      {!summary.length && !tips.length ? (
        <p className="m-0 text-sm text-[#6E5E8A]">Зөвлөх тэмдэглэл хараахан оруулаагүй байна.</p>
      ) : (
        <>
          {summary.map((n) => <p key={n.id} className="m-0 text-sm leading-relaxed whitespace-pre-wrap text-gray-900">{n.text}</p>)}
          {tips.length > 0 && (
            <>
              <span className="tds-eyebrow mt-1">Сануулга, зөвлөмж</span>
              <ul className="m-0 pl-5 flex flex-col gap-1.5 text-sm leading-relaxed list-disc marker:text-[#5C1090]">
                {tips.map((n) => <li key={n.id} className="whitespace-pre-wrap">{n.text}</li>)}
              </ul>
            </>
          )}
        </>
      )}
    </Card>
  );
}

// Миний тэмдэглэл: нэг текст талбар — бичихээ зогсоход (1.2с) / гарахад автоматаар хадгална
function MyNotes({ m, onChanged }) {
  const mine = m.notes.filter((n) => n.kind === "private");
  const first = mine[0] || null;
  const [text, setText] = useState(first?.text || "");
  const [state, setState] = useState(first ? "saved" : "idle");
  const [savedAt, setSavedAt] = useState(null);
  const noteId = useRef(first?.id || null);
  const lastSaved = useRef(first?.text || "");
  const timer = useRef(null);
  const saving = useRef(Promise.resolve());

  const save = useCallback((val) => {
    saving.current = saving.current.then(async () => {
      const v = val.trim();
      if (v === lastSaved.current.trim()) return;
      setState("saving");
      try {
        if (!v && noteId.current) {
          await api("delete", `/meeting/${m.id}/note/${noteId.current}`);
          noteId.current = null;
        } else if (v && noteId.current) {
          await api("put", `/meeting/${m.id}/note/${noteId.current}`, { text: v });
        } else if (v) {
          const n = await api("post", `/meeting/${m.id}/note`, { text: v });
          noteId.current = n?.id || null;
        }
        lastSaved.current = val;
        setSavedAt(new Date());
        setState(v ? "saved" : "idle");
        onChanged && onChanged();
      } catch (e) {
        setState("error");
      }
    });
  }, [m.id, onChanged]);

  useEffect(() => () => clearTimeout(timer.current), []);
  const onChange = (e) => {
    const v = e.target.value;
    setText(v);
    setState("dirty");
    clearTimeout(timer.current);
    timer.current = setTimeout(() => save(v), 1200);
  };
  const status =
    state === "saving" ? "Хадгалж байна…"
    : state === "dirty" ? "Бичиж байна…"
    : state === "error" ? "Хадгалж чадсангүй — дахин оролдоно уу"
    : state === "saved" ? `Автоматаар хадгалагдсан${savedAt ? ` · ${hm(savedAt)}` : ""}`
    : "Бичсэн зүйл автоматаар хадгалагдана";

  return (
    <Card aria-labelledby="mn-h">
      <div className="flex items-baseline justify-between gap-2.5">
        <label id="mn-h" htmlFor="my-notes" className="tds-h2">Миний тэмдэглэл</label>
        <span className="text-xs text-[#6E5E8A] shrink-0">Зөвхөн танд харагдана</span>
      </div>
      <Input.TextArea id="my-notes" value={text} onChange={onChange} onBlur={() => { clearTimeout(timer.current); save(text); }}
        autoSize={{ minRows: 5, maxRows: 14 }} maxLength={5000} placeholder="Уулзалтын өмнө, үеэр, дараа нь тэмдэглэ…" />
      <span role="status" className={`text-xs ${state === "error" ? "text-red-600" : "text-[#6E5E8A]"}`}>{status}</span>
      {mine.slice(1).map((n) => (
        <p key={n.id} className="m-0 text-sm whitespace-pre-wrap rounded-xl bg-[#F7F0FF] px-3.5 py-3">{n.text}</p>
      ))}
    </Card>
  );
}

function RatingModal({ open, m, onClose, onSaved }) {
  const [stars, setStars] = useState(m.rating?.stars || 0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState(m.rating?.comment || "");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) { setStars(m.rating?.stars || 0); setComment(m.rating?.comment || ""); } }, [open, m.rating]);
  const shown = hover || stars;
  const submit = async () => {
    setSaving(true);
    try {
      await api("post", `/meeting/${m.id}/rating`, { stars, comment: comment.trim() || null });
      message.success("Үнэлгээ илгээгдлээ. Баярлалаа!");
      onSaved();
    } catch (e) {
      // алдааг interceptor харуулна
    } finally {
      setSaving(false);
    }
  };
  return (
    <Modal open={open} onCancel={onClose} footer={null} centered width={480} destroyOnClose
      title={<span className="text-lg font-bold">Уулзалт ямар байсан бэ?</span>}>
      <p className="m-0 mt-1 text-sm text-[#6E5E8A]">{fullName(m.counselor)}-тэй хийсэн уулзалтаа үнэлнэ үү. Таны үнэлгээ зөвлөхөд харагдана.</p>
      <div className="flex flex-col gap-4 mt-4">
        <div className="flex flex-col items-center gap-1.5">
          <div role="radiogroup" aria-label="Од" className="flex gap-1" onMouseLeave={() => setHover(0)}>
            {[1, 2, 3, 4, 5].map((i) => (
              <button key={i} type="button" role="radio" aria-checked={stars === i} aria-label={`5-аас ${i} од — ${STAR_WORDS[i]}`}
                onClick={() => setStars(i)} onMouseEnter={() => setHover(i)}
                className="p-1 rounded-lg leading-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#5C1090]">
                <Star on={i <= shown} size={40} strokeWidth={1.5} />
              </button>
            ))}
          </div>
          <span className="text-sm font-semibold text-[#5C1090] min-h-[20px]">{STAR_WORDS[shown]}</span>
        </div>
        <label className="flex flex-col gap-1.5" htmlFor="rv">
          <span className="text-sm font-semibold text-gray-900">Товч сэтгэгдэл</span>
          <Input.TextArea id="rv" value={comment} onChange={(e) => setComment(e.target.value)} autoSize={{ minRows: 4, maxRows: 8 }} maxLength={2000}
            placeholder="Юу хамгийн их тус болсон бэ? Юуг өөрөөр хийвэл дээр вэ?" />
        </label>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="h-10 px-4 rounded-[10px] text-sm font-medium text-gray-700 hover:bg-[#FAF7FF]">Дараа үнэлэх</button>
          <button type="button" onClick={submit} disabled={!stars || saving} className={purpleBtn}>{saving && <Spin size="small" />} Илгээх</button>
        </div>
      </div>
    </Modal>
  );
}

export default function CounselingSession() {
  const { id } = useParams();
  const [m, setM] = useState(null);
  const [err, setErr] = useState(null);
  const [rateOpen, setRateOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const autoOpened = useRef(false);

  const load = useCallback(() =>
    api("get", `/meeting/${id}`).then((d) => { setM(d); setErr(null); return d; })
      .catch((e) => { setErr(e?.response?.data?.error || "Уулзалт ачаалж чадсангүй"); return null; }), [id]);

  useEffect(() => {
    autoOpened.current = false;
    load().then((d) => {
      // Дууссан, үнэлээгүй уулзалт — нэг удаа үнэлгээний цонх нээнэ (мэдэгдлээс орж ирэхэд)
      if (!d || d.stage !== "done" || d.rating || autoOpened.current) return;
      autoOpened.current = true;
      let seen = false;
      try { seen = sessionStorage.getItem(`cs-rate-${d.id}`) === "1"; sessionStorage.setItem(`cs-rate-${d.id}`, "1"); } catch (e) { /* хадгалах боломжгүй */ }
      if (!seen) setRateOpen(true);
    });
  }, [load]);

  // Дуусаагүй уулзалт — төлөв (баталгаажсан, эхэлсэн, холбоос) өөрчлөгдөхийг 60с тутам шалгана
  useEffect(() => {
    if (!m || ["done", "cancelled"].includes(m.stage)) return undefined;
    const t = setInterval(() => { if (document.visibilityState === "visible") load(); }, 60000);
    return () => clearInterval(t);
  }, [m, load]);

  const toggle = async (a, done) => {
    setBusy(a.id);
    setM((x) => ({ ...x, actions: x.actions.map((y) => (y.id === a.id ? { ...y, doneAt: done ? new Date().toISOString() : null } : y)) }));
    try { await api("put", `/action/${a.id}`, { done }); } catch (e) { load(); } finally { setBusy(null); }
  };
  const cancel = async () => {
    setCancelling(true);
    try {
      await api("put", `/meeting/${m.id}/cancel`);
      message.success("Уулзалт цуцлагдлаа");
      setM((x) => ({ ...x, stage: "cancelled", status: "cancelled" }));
    } catch (e) {
      load();
    } finally {
      setCancelling(false);
    }
  };

  if (err && !m) {
    return (
      <div className="pt-6 pb-8 max-w-3xl mx-auto flex flex-col gap-4">
        <Link to="/counseling" className="text-sm text-[#5C1090] inline-flex items-center gap-1"><FiArrowLeft size={14} /> Зөвлөгөө</Link>
        <div className="tds-card p-6"><Empty icon={FiInbox} title={err} text="Уулзалт цуцлагдсан эсвэл танд хамааралгүй байж магадгүй." /></div>
      </div>
    );
  }
  if (!m) return <div className="flex justify-center py-16"><Spin /></div>;

  const done = m.stage === "done";
  const hero = <Hero m={m} onCancel={cancel} cancelling={cancelling} />;

  const ratingCard = done && (
    <Card aria-labelledby="rate-h">
      <h2 id="rate-h" className="tds-h2">Миний үнэлгээ</h2>
      {m.rating ? (
        <>
          <div className="flex items-center gap-3">
            <Stars n={m.rating.stars} size={22} />
            <span className="text-lg font-extrabold text-[#5C1090]">{m.rating.stars} / 5</span>
          </div>
          {m.rating.comment && <blockquote className="m-0 px-3.5 py-3 rounded-xl bg-[#F7F0FF] text-sm leading-relaxed whitespace-pre-wrap">{m.rating.comment}</blockquote>}
          <div className="flex items-center justify-between gap-2">
            <span className="text-xs text-[#6E5E8A]">Зөвлөхөд харагдана</span>
            <button type="button" onClick={() => setRateOpen(true)} className="text-sm font-bold text-[#5C1090] hover:underline">Засах</button>
          </div>
        </>
      ) : (
        <>
          <p className="m-0 text-sm text-[#6E5E8A]">Энэ уулзалтыг үнэлээгүй байна.</p>
          <button type="button" onClick={() => setRateOpen(true)} className={`${purpleBtn} self-start`}>Үнэлгээ өгөх</button>
        </>
      )}
    </Card>
  );

  const actionsCard = (done || m.actions.length > 0) && (
    <Card aria-labelledby="ai-h">
      <div className="flex items-baseline justify-between gap-2">
        <h2 id="ai-h" className="tds-h2">Хийх ажил</h2>
        {m.actions.length > 0 && <span className="text-[13px] text-[#6E5E8A]">{m.actions.filter((a) => !a.doneAt).length} үлдсэн</span>}
      </div>
      {m.actions.length ? (
        <ul className="list-none m-0 p-0 border border-[#E5D8F5] rounded-xl bg-white">
          {m.actions.map((a) => <ActionItem key={a.id} a={a} busy={busy === a.id} onToggle={toggle} />)}
        </ul>
      ) : (
        <p className="m-0 text-sm text-[#6E5E8A]">Энэ уулзалтаас өгсөн ажил алга.</p>
      )}
    </Card>
  );

  const topicCard = (
    <Card aria-labelledby="topic-h">
      <span id="topic-h" className="tds-eyebrow">Уулзалтын сэдэв</span>
      <p className="m-0 text-lg md:text-xl font-bold leading-snug break-words">{m.topic || "Сэдэв оруулаагүй"}</p>
      {m.request && (
        <>
          <span className="text-[13px] font-semibold text-[#6E5E8A]">Миний хүсэлтээс</span>
          <blockquote className="m-0 px-3.5 py-3 rounded-xl bg-[#F7F0FF] text-sm leading-relaxed whitespace-pre-wrap break-words">{m.request}</blockquote>
        </>
      )}
    </Card>
  );

  return (
    <div className="pt-4 md:pt-6 pb-8 flex flex-col gap-5 md:gap-6">
      <div className="flex flex-col gap-3.5">
        <nav aria-label="Байршил" className="text-[13px] text-[#6E5E8A] flex items-center gap-1.5 flex-wrap">
          <Link to="/counseling" className="text-[#5C1090] hover:text-[#3d1b6e] inline-flex items-center gap-1"><FiArrowLeft size={14} /> Зөвлөгөө</Link>
          <span aria-hidden="true">/</span><span className="text-gray-900 font-semibold">Уулзалт</span>
        </nav>
        <div className="flex flex-wrap items-end justify-between gap-3">
          <h1 className="tds-h1 break-words min-w-0">Уулзалт: {fullName(m.counselor) || "Зөвлөх"}</h1>
          <Badge stage={m.stage} className="!text-[13px] !px-3 !py-1" />
        </div>
        <dl className="m-0 grid grid-cols-2 lg:grid-cols-4 gap-2.5 md:gap-3">
          <Info label="Огноо" value={longDate(m.startTime)} />
          <Info label="Цаг" value={timeRange(m.startTime, m.durationMin)} />
          <Info label="Үргэлжлэх хугацаа" value={durationText(m)} />
          <Info label="Хэлбэр" value={typeText(m)} />
        </dl>
      </div>

      {done ? (
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5 items-start">
          <div className="lg:col-span-3 flex flex-col gap-4 md:gap-5 min-w-0">
            <CounselorNotes m={m} />
            {actionsCard}
            {topicCard}
          </div>
          <aside className="lg:col-span-2 flex flex-col gap-4 md:gap-5 min-w-0">
            {ratingCard}
            <MyNotes m={m} />
          </aside>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5 items-start">
          <div className="lg:col-span-3 flex flex-col gap-4 md:gap-5 min-w-0">
            {hero}
            {m.stage !== "cancelled" && m.notes.some((n) => n.kind !== "private") && <CounselorNotes m={m} />}
            {actionsCard}
          </div>
          <aside className="lg:col-span-2 flex flex-col gap-4 md:gap-5 min-w-0">
            {topicCard}
            {m.stage !== "cancelled" && <MyNotes m={m} />}
          </aside>
        </div>
      )}

      {done && <RatingModal open={rateOpen} m={m} onClose={() => setRateOpen(false)} onSaved={() => { setRateOpen(false); load(); }} />}
    </div>
  );
}
